'use client';

import { configureSync, getConsoleSink } from '@logtape/logtape';

import { getDatadogClientSink } from './logger/sinks/datadog.client';

import { EnvironmentNameEnum, getEnvironmentName } from '@/config/environment';
import {
  RouterNavigationType,
  trackDocumentNavigation,
  trackRouterNavigation,
} from '@/utils/history-navigation.util';

const isLocal = getEnvironmentName() === EnvironmentNameEnum.LOCAL;

trackDocumentNavigation();

export function onRouterTransitionStart(url: string, navigationType: RouterNavigationType) {
  trackRouterNavigation(url, navigationType);
}

configureSync({
  sinks: {
    console: getConsoleSink(),
    datadog: getDatadogClientSink(),
    meta: getConsoleSink({
      formatter: (record) =>
        `[META] ${record.level} ${record.message}`,
    }),
  },
  loggers: [
    {
      category: 'app',
      lowestLevel: isLocal ? 'debug' : 'info',
      sinks: isLocal ? ['console'] : ['datadog'],
    },
    {
      category: ['logtape', 'meta'],
      lowestLevel: 'warning',
      sinks: ['meta'],
    },
  ],
});
